import { getPlacementLabel } from "./themeEditorLinks";

export const ANALYTICS_BAR_FILTER_OPTIONS = [
  { label: "All bars", value: "all" },
  { label: "Product page", value: "placement:product_page" },
  { label: "Cart page", value: "placement:cart_page" },
  { label: "Home page", value: "placement:home_page" },
  { label: "Store-wide bar", value: "placement:announcement_bar" },
];

export function analyticsFilterLabel(value) {
  return ANALYTICS_BAR_FILTER_OPTIONS.find((o) => o.value === value)?.label || "All bars";
}

export function filterAnalyticsBarRows(rows, filterKey) {
  const key = filterKey || "all";
  if (key === "all") return rows;
  if (key.startsWith("placement:")) {
    const placement = key.slice("placement:".length);
    return rows.filter((row) => row.placement_type === placement);
  }
  return rows;
}

export function searchAnalyticsBarRows(rows, query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return rows;

  return rows.filter((row) => {
    const placement = getPlacementLabel(row.placement_type);
    const hay = [row.name, placement, row.placement_type, row.public_id].join(" ").toLowerCase();
    return hay.includes(q);
  });
}
